import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router';
import { RequirePermission } from '@routes/RequirePermission';
import { PERMISSIONS } from '@auth/permissions';

const NewsItemsOverview = lazy(() =>
  import('@pages/Management/News/NewsItemsOverview').then((m) => ({
    default: m.NewsItemsOverview,
  }))
);

const NewsItemDetails = lazy(() =>
  import('@pages/Management/News/NewsItemDetails').then((m) => ({
    default: m.NewsItemDetails,
  }))
);

const CreateNewsItem = lazy(() =>
  import('@pages/Management/News/CreateNewsItem').then((m) => ({
    default: m.CreateNewsItem,
  }))
);

const EditNewsItem = lazy(() =>
  import('@pages/Management/News/EditNewsItem').then((m) => ({
    default: m.EditNewsItem,
  }))
);

export const manageNewsRoutes = (
  <Route
    element={<RequirePermission permission={PERMISSIONS.newsItems.view} />}
  >
    <Route path="news">
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<NewsItemsOverview />} />

      <Route
        element={
          <RequirePermission permission={PERMISSIONS.newsItems.create} />
        }
      >
        <Route path="overview/new" element={<CreateNewsItem />} />
      </Route>

      <Route
        element={
          <RequirePermission permission={PERMISSIONS.newsItems.update} />
        }
      >
        <Route path="overview/edit/:id" element={<EditNewsItem />} />
      </Route>

      <Route path="overview/:id" element={<NewsItemDetails />} />
    </Route>
  </Route>
);
